module.exports = __webpack_public_path__ + "static/img/15-Didcot-housing-and-community-development.4ea7fa3f.png";